import { render, staticRenderFns } from "./InputBarangMasuk.vue?vue&type=template&id=85be1fa0&"
import script from "./InputBarangMasuk.vue?vue&type=script&lang=js&"
export * from "./InputBarangMasuk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports